import { AppConfig } from "../helpers";

export const Currency = {
	LiberianDollar: 1,
	USD: 2,
}
export const Feed = {
	Static: 6,
	Live: 5,

	//Virtual
	VFL: 1,
	VHC: 2,
	VDR: 3,
	VTO: 4,
	VFLM: 7,
	VBL: 8,
	EPL: 9,

	Casino:10,
	SpinAndWin:13,

	Home: 6,
	Fixture: 10001,
	Slots:10002,
	ContactUs:10003,
	WorkWithUs:10004,
	WorldCup:10005,
	Promos: 11,
	LuckyNumbers:15,
	Landing:1,
	virtualSports:19
}

export const VirtualFeedIds = [1, 2, 3, 4, 7, 8, 9];

export const FeedNames = {
	Static: "sport",
	Live: "live",
	VFL: "virtual",

	Home: "sport",
	Fixture: "Fixture",
	Slots:"slots",
	Casino: "casino",
	Promos:"promos",
	LuckyNumbers:"lucky-numbers",
	Landing:"landing-page",
	virtualSports:"virtualSports"

}

export const FeedChangeStatus = {
	Update: 0,
	Add: 1,
	Delete: 2,

}
export const daysFormatted = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

export const Days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
// export const calenderDays = [{name:"SUN" , id:1},{name:"MON" , id:2},{name:"TUE" , id:3},{name:"WED" , id:4},{name:"THU" , id:5},{name:"FRI" , id:6},{name:"SAT" , id:7}]

export const Status = {
	Success: 1,
	Warning: 2,
	Error: 3,
	TokenExpired: 4
}

export const Device = {
	Size1: 1,
	Size2: 2,
	Size3: 3,
	Size4: 4,
	Size5: 5,
	Size6: 6,
	Size7: 7,
}

export const Env = {
	PROD: "PROD",
	PRODV1: "PRODV1",
	DEV: "DEV",
	DEV_HTTPS: "DEV_HTTP",
	LOCAL: "LOCAL",
	UK: "UK",
}

export const JackpotLevel = {
	"Gold": 1,
	"Silver": 2,
	"Bronze": 3,
	"Bonus": 4,
	"DailyMega"	:5,
	"Web"	:6,
	"SingleGame":7
}

export const metaData = {
	"home" : {
		title : `Winners | Sports Betting & Top Odds | Liberia’s Sportsbook`,
		description : `Winners Inc the pioneer & #1 Sports Betting company in Liberia. Enjoy the 
					Best Online & Retail Gaming experience with the most trusted brand in the 
					country`
	},
	"soccer":{
		title : `Winners | Liberia's Choice to Bet on Soccer Online | Bet Now`,
		description : `Top soccer betting odds on English Premier League, Champions League, 
and more @ Winners. Bet live on your favorite teams & win big with the 
highest odds!`
	},
	"basketball":{
		title : `Winners Basketball Betting | Top NBA Betting Odds | Join Now`,
		description : `Winners has top basketball betting odds for NBA & international 
tournaments. Bet live & enjoy the highest odds & thrilling bonuses. Join 
now & make your picks!`
	},
	"tennis":{
		title : `Winners | Grand Slam Betting Odds | Tennis Betting Online`,
		description : `Bet on Grand Slam & ATP tennis with Winners. Discover top tennis betting 
odds, live betting & exciting bonuses. Sign up and place your bets on 
tennis today!`
	},
	"baseball":{
		title : `Winners | MLB Baseball Betting Odds | Bet on Baseball Now`,
		description : `Bet on MLB with Winners, Liberia's leading sportsbook. Enjoy top baseball 
betting odds, live betting, & exciting promotions. Join today & get in on the 
action!`
	},
	"icehockey":{
		title : `Winners | NHL Ice Hockey Odds | Bet Now on Ice Hockey`,
		description : `Place your bets on NHL and international ice hockey at Winners Inc. Get 
the best ice hockey betting odds in Liberia, live action, & secure betting. 
Sign Up Now!`
	},
	"handball":{
		title : `Handball Betting | International Handball Odds | Winners`,
		description : `Winners has the highest odds in Liberia on international handball matches. 
Bet live on top handball leagues with secure transactions & exciting 
bonuses. Bet now!`
	},
	"boxing":{
		title : `Winners | Top Boxing Odds & Major Fight Betting | Bet Now`,
		description : `Bet on boxing with Winners. Enjoy live betting on world championship fights 
and get the best boxing odds. Join Winners today and make your bets count!`
	},
	"rugby":{
		title : `Winners Rugby Betting | Top International Rugby Odds | Bet Now`,
		description : `Bet on rugby from international & domestic leagues at Winners. Get the best 
rugby betting odds in Liberia, live bets, & secure betting options. Join now!`
	},
	"cricket":{
		title : `Winners Cricket Betting | Test Match, T20 & ODI | Join Now`,
		description : `Bet on Test matches, T20 & ODIs with Winners Inc. Discover the best cricket 
betting odds & live betting options. Join Liberia’s top sportsbook today!`
	},
	"volleyball":{
		title : `Winners Inc | Get Top Volleyball Betting Odds | Sign Up Now`,
		description : `Place your volleyball bets on international matches at Winners. Get the best 
volleyball betting odds & live betting. Join now and enjoy the volleyball action!`
	},
	"futsal":{
		title : `Futsal Betting | Futsal Odds & Live Betting | Winners Inc`,
		description : `Bet on top Futsal matches with Winners. Get the best Futsal betting odds & 
exciting promotions. Join Liberia’s top sportsbook & place your Futsal bets 
today!`
	},
	"mma":{
		title : `Winners Sports Betting | UFC & MMA Betting Odds | Join Now`,
		description : `Bet on UFC & MMA @ Winners. Enjoy top odds, live betting on major events & 
secure transactions. Join today for the best MMA betting experience in Liberia!`
	},
	"live":{
		title : `Live Soccer Betting | Top Odds In Real-Time | Winners Liberia`,
		description : `Bet live soccer with real-time odds at Winners. Follow the latest 
English Premier League & Champions League matches & enjoy 
in-play betting for every goal!`
	},
	"virtual":{
		title : `Virtual Sports Betting | 24/7 Action & Instant Wins | Winners`,
		description : `Experience nonstop sports betting play with Winners Liberia's 
virtual sports betting. Bet on simulated sports with fast outcomes & 
realistic gameplay, anytime!`
	},
	"slots":{
		title : `Online Slots | Spin & Win Big Jackpots | Winners Liberia`,
		description : `Play hot online slots at Winners Liberia & hit massive jackpots. 
Enjoy themed games with bonus rounds, free spins & big wins. 
Start spinning & winning now!`
	},
	"promos":{
		title : `Sports Betting Promotions | Bonuses & Free Bets | Winners`,
		description : `Maximize your winnings with the latest promotions at Winners! Get 
exclusive bonuses, free bets & special offers for new & loyal 
customers. Bet now, win more!`
	},
	"luckyNumbers":{
		title : `Lucky Numbers | Win with Your Favorite Numbers | Winners`,
		description : `Bet on your favorite lucky numbers for a chance to win big with 
Winners Liberia. Play daily draws and increase your odds of hitting 
it big. Play Now!`
	},
	"aboutUs":{
		title : `About Winners | Leading Sports Betting in Liberia`,
		description : `Discover more about Liberia’s top sports betting platform. Learn 
about our commitment to fair play & passion for delivering top 
sports betting experiences.`
	},
	"contactUs":{
		title : `Contact Winners | Customer Support & Help Center`,
		description : `Need help or have questions? Contact Winners today! Our 
customer support team is ready to assist with inquiries on betting, 
account management and more.`
	},
	"termsAndConditions":{
		title : `Terms & Conditions | Betting Guidelines at Winners Liberia`,
		description : `Read the full terms and conditions for using Winners. Learn about 
our rules, policies, and guidelines to ensure fair and responsible 
betting on our platform.`
	},
	"privacyPolicy":{
		title : `Privacy Policy | How Winners Protects Your Data`,
		description : `Learn how we protect your personal info. Read our privacy policy 
to understand how we collect, use & safeguard your data & 
ensure secure online betting.`
	},
	"responsibleGaming":{
		title : `Responsible Gaming | Play Safe with Winners Liberia`,
		description : `We are committed to responsible gaming. Get tips on how to 
manage your betting & find resources to help you stay in control. 
Winners play responsibly.`
	},
	"cookiesPolicy":{
		title : `Cookies Policy | How Winners Uses Cookies`,
		description : `Learn how we use cookies to enhance your online betting. 
Understand how cookies work & how you can manage them for a 
better browsing experience.`
	},
	"generalBettingRules":{
		title : `General Betting Rules | Understand Betting at Winners`,
		description : `Familiarize yourself with Winners' betting rules. Get to know 
guidelines for placing bets, settling wagers & more to ensure a 
smooth, fair betting experience.`
	},
	"howToPlay":{
		title : `How To Play | Guide to Sports Betting & Games at Winners`,
		description : `New to betting? Learn how to play at Winners with our 
comprehensive guide. From soccer betting to slots & virtual 
sports, get step-by-step instructions and win!`
	},
	"workWithUs":{
		title : `Work With Winners | Careers & Opportunities in Sports Betting`,
		description : `Join the Winners team! Explore exciting career opportunities in 
Liberia’s leading sports betting company. Be part of a dynamic 
industry with great prospects.`
	},
	"casino":{
        title: `Winners`,
        description: `Winners Inc the pioneer & #1 Sports Betting company in Liberia. Enjoy the Best Online & Retail Gaming experience with the most trusted brand in the country`,
    },
	"soccerMarkets":{
        title: `Know Your Soccer Betting Rules & Markets in Liberia | Winners`,
        description: `Detailed soccer betting rules and markets with Winners. From 
match outcomes to corners and player props, learn how to bet 
smarter in Liberia’s favorite sport.`,
    },
	"basketballMarkets":{
        title: `Basketball Betting Rules & Markets in Liberia | Winners`,
        description: `Explore basketball betting rules and markets with Winners Inc in 
Liberia. Learn about spreads, totals, player stats, and unique bets 
for NBA and FIBA games.`,
    },
	"americanFootballMarkets":{
        title: `Know Your American Football Betting Rules & Markets | Winners`,
        description: `Bet on American Football like a pro with Winners Inc. Understand 
betting rules and markets for NFL, college games, and more, 
tailored for Liberian bettors.`,
    },
	"badmintonMarkets":{
        title: `Badminton Betting Rules & Markets Explained | Winners`,
        description: `Get into badminton betting with Winners Inc. Learn the rules, 
markets, and strategies to bet on this fast-paced sport in Liberia.`,
    },
	"baseballMarkets":{
        title: `Discover Baseball Betting Rules & Markets | Winners`,
        description: `Get to know your baseball betting with Winners Inc in Liberia. From 
MLB moneylines to run totals, master the rules & markets for 
winning bets.`,
    },
	"beachVolleyballMarkets":{
        title: `Beach Volleyball Betting Rules & Markets Made Easy | Winners`,
        description: `Ace your beach volleyball bets with Winners Inc. Explore betting 
rules and unique markets for thrilling Liberian volleyball action.`,
    },
	"bowlMarkets":{
        title: `Bowling Betting Rules & Markets for Liberia | Winners`,
        description: `Roll into bowling betting with Winners Inc in Liberia. Learn the 
markets, rules, and strategies to make your sports betting count.`,
    },
	"tennisMarkets":{
        title: `Get The Low Down On Tennis Betting Rules & Tips | Winners`,
        description: `Winners Liberia offers detailed tennis betting rules. Bet on ATP, 
WTA, and Grand Slam events with our market-specific guidelines.`,
    },
	"cricketMarkets":{
        title: `Cricket Betting Rules & Markets For Everyone | Winners`,
        description: `Score big with cricket betting at Winners Inc in Liberia. 
Understand rules, markets, and tips for IPL, Test matches, and 
T20 leagues.`,
    },
	"dartsMarkets":{
        title: `Get To Know Your Darts Betting Rules & Markets | Winners`,
        description: `Hit the bullseye with darts betting at Winners Inc. Learn the rules, 
markets, and tips for successful darts wagers in Liberia.`,
    },
	"handballMarkets":{
        title: `Handball Betting Rules Explained | Winners`,
        description: `Stay ahead with Winners Inc’s guide to handball betting in 
Liberia. Explore rules and markets for top leagues and 
tournaments.`,
    },
	"icehockeyMarkets":{
        title: `Ice Hockey Betting Rules & Markets in Liberia | Winners`,
        description: `Learn how to bet on ice hockey with Winners Liberia. Understand 
NHL and international league betting rules, including moneylines 
and puck lines.`,
    },
	"rugbyMarkets":{
        title: `Rugby Betting Rules & Tips for Liberia | Winners`,
        description: `Master rugby betting with Winners Liberia. Explore rules, 
markets, and strategies for Rugby Union, Rugby League, and 
World Cup games.`,
    },
	"rugbyMarkets":{
        title: `Rugby Betting Rules & Tips for Liberia | Winners`,
        description: `Master rugby betting with Winners Liberia. Explore rules, 
markets, and strategies for Rugby Union, Rugby League, and 
World Cup games.`,
    },
	"snookerMarkets":{
        title: `Snooker Betting Rules & Odds in Liberia | Winners`,
        description: `Winners Liberia brings you snooker betting rules and market 
insights. Bet on frame winners, match results, and tournament 
outcomes with confidence.`,
    },
	"squashMarkets":{
        title: `Squash Betting Rules & Strategies for Liberia | Winners`,
        description: `Dive into squash betting rules at Winners Liberia. Learn how to 
bet on match outcomes, set scores, and player performances.`,
    },
	"volleyballMarkets":{
        title: `Volleyball Betting Rules & Markets | Winners Liberia`,
        description: `Explore volleyball betting at Winners Liberia. Learn rules, odds, 
and strategies for betting on set winners, totals, and match 
outcomes.`,
    },
}

//export const ShowSignIn = true